<template>
    <DropdownMenu :items="items" @open="handleOpen" @choose="handleChoice">
        <FormButton :variant="ButtonVariants.SECONDARY">
            <span class="block pr-4 text-sm font-medium">{{
                $t("locale.current")
            }}</span>
            <Icon :icon="localeIcon" class="pointer-events-none size-5" />
        </FormButton>
    </DropdownMenu>
</template>

<script>
import { LocaleStoreNamespacedTypes } from "@/store/modules/locale";
import AmplitudeMixin from "@/mixins/AmplitudeMixin";

import { localeEn, localeDa, localeDe } from "@/utils/enums";
import DropdownMenu from "@/components/ui/DropdownMenu";
import FormButton, {
    ButtonVariants,
} from "@/components/forms/fields/FormButton";
import Icon from "@/components/icons/BaseIcon";
import { IconEnums } from "@/utils/icons";

export default {
    name: "LocaleSwitcher",
    mixins: [AmplitudeMixin],
    components: { DropdownMenu, FormButton, Icon },
    data: () => ({
        ButtonVariants,
        IconEnums,
        localeEn,
        localeDa,
        localeDe,
    }),
    computed: {
        items() {
            return [
                {
                    id: localeDa,
                    label: this.$t("locale.danish"),
                    icon: IconEnums.DANISH,
                },
                {
                    id: localeEn,
                    label: this.$t("locale.english"),
                    icon: IconEnums.ENGLISH,
                },
                {
                    id: localeDe,
                    label: this.$t("locale.german"),
                    icon: IconEnums.GERMAN,
                },
            ];
        },

        /**
         * Current locale.
         * @type {String}
         */
        locale() {
            return this.$store.getters[
                LocaleStoreNamespacedTypes.getters.LOCALE
            ]();
        },
        localeIcon() {
            switch (this.locale) {
                case localeEn:
                    return IconEnums.ENGLISH;
                case localeDa:
                    return IconEnums.DANISH;
                case localeDe:
                    return IconEnums.GERMAN;
                default:
                    return IconEnums.ENGLISH;
            }
        },
    },
    methods: {
        handleOpen() {
            this.trackAmplitudeEvent("language_previewed");
        },
        handleChoice(item) {
            this.$store
                .dispatch(
                    LocaleStoreNamespacedTypes.actions.UPDATE_LOCALE,
                    item.id
                )
                .then(() => {
                    this.trackAmplitudeEvent("language_selected", {
                        selected: item.id,
                    });
                });
        },
    },
};
</script>
